<div *ngIf="!!event?.closed" class="closed_msg" 
  [innerHTML]="publicHelpers.strWithBreak('This event is closed. Only active events have ' + capitalEntity + ' Brief.\n\nAny shareable ' + (performer ? 'performer' : 'exhibitor') + ' briefs have been turned off.')">
</div>
<branding-wrapper 
  [brandingData]="!!event && !!timelineOnly ? null : brandingData"
  [ngClass]="{ withBranding: brandingData }"
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <brief-view *ngIf="!event.closed && !timelineOnly && !!event && 
    { contact: workersByEmail[briefType === 'performer' ? performer?.contact : 
      briefType === 'exhibitor' ? exhibitor?.workforceContactEmail : 
      briefType === 'attendee' ? attendee?.WFContact :
      resource?.workforceContactEmail] } as vars"
    [publicView]="false"
    [capitalEntity]="capitalEntity"
    [briefProgramPublishes]="briefProgramPublishes"
    [briefLogisticsViews]="briefLogisticsViews"
    [briefOnsiteViews]="briefOnsiteViews"
    [lowerEntity]="lowerEntity"
    [eventTitle]="event.title"
    [eventId]="event.eventId"
    [mediaTerms]="mediaTerms"
    [performer]="performer"
    [exhibitor]="exhibitor"
    [attendee]="attendee"
    [resource]="resource"
    [entity]="performer || exhibitor || resource || attendee"
    [exhibitorSummaries]="exhibitorSummaries"
    [shareCode]="briefInfo?.id"
    [performers]="performers"
    [briefType]="briefType"
    [sponsors]="sponsors"
    [sponsorTypes]="sponsorTypes"
    [venues]="event.venues"
    [workforceContactProfile]="vars.contact"
    [workforceContactInactive]="!!vars.contact && vars.contact.status !== 'accepted'"
    [timeline]="timeline"
    [performerRoles]="performerRoles"
    [labelMaps]="labelMaps"
    [allEntityInformable]="allEntityInformable"
    [singleEntityInformable]="singleEntityInformable"
    [briefActions]="briefActions"
  ></brief-view>
  <brief-timeline *ngIf="!!event && !!timelineOnly"
    [standalone]="true"
    [performers]="performers"
    [sponsors]="sponsors"
    [sponsorTypes]="sponsorTypes"
    [performer]="performer"
    [exhibitor]="exhibitor"
    [resource]="resource"
    [eventTitle]="event.title"
    [eventId]="event.eventId"
    [labelMaps]="labelMaps"
    [publicView]="true"
    [performerRoles]="performerRoles"
    [venues]="event.venues"
    [unavailable]="false"
    [timeline]="timeline"
    [shareCode]="briefInfo?.id"
  ></brief-timeline>
</branding-wrapper>